import { render, staticRenderFns } from "./UserCommentCard.vue?vue&type=template&id=53955d2e&scoped=true"
import script from "./UserCommentCard.vue?vue&type=script&lang=js"
export * from "./UserCommentCard.vue?vue&type=script&lang=js"
import style0 from "./UserCommentCard.vue?vue&type=style&index=0&id=53955d2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53955d2e",
  null
  
)

export default component.exports